import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { RestApiModel } from '../../../shared/model/rest-api.model';
import { SortUtils } from '../../../shared/utils/sort.utils';
import { PartsTypeModel } from '../../partType/model/part-type.model';

/**
 * @name PartsService
 */
@Injectable()
export class PartTypeService {
  constructor(private http: HttpClient) {}
  /**
   * Retrieve Product Lines for parts
   * @returns {Observable<Array<any>>}
   */
  getPartTypes(): Observable<Array<any>> {
    return this.http
      .get(RestApiModel.PROXY_API_URL + '/partTypes')
      .map((res: any) => {
        return res.results
          ? res.results.sort((a: any, b: any) =>
              SortUtils.compareByProperty(a, b, 'name')
            )
          : null;
      })
      .catch(err => {
        return throwError(err);
      });
  }

  /**
   * PUT - edit a parts type.
   * @param {PartsTypeModel} PartsTypeModel
   * @returns {Observable<any>}
   */
  updatePartType(partType: PartsTypeModel): Observable<any> {
    return this.http
      .put(RestApiModel.PROXY_API_URL + '/partType/' + partType.id, partType)
      .catch(err => {
        return throwError(err);
      });
  }

  /**
   * POST - Create a new part type.
   * @param {PartsTypeModel} PartsTypeModel
   * @returns {Observable<any>}
   */
  createPartType(partType: PartsTypeModel): Observable<any> {
    return this.http
      .post(RestApiModel.PROXY_API_URL + '/partType/', partType as any)
      .map((res: any) => res)
      .catch(err => {
        return throwError(err);
      });
  }
}
